import React, { ReactElement, useEffect, useState } from 'react';
import { ModeleCourriel } from '../../../../../common/src/entities';
import { FormulaireCreationEntite, PropsDeCreationEntite } from '../Utils/FormulaireCreationEntite';
import { useAlertDialog } from '../../../Utils/dialogContext';
import { ChampsModeleCourriel } from './DetailsModeleCourriel'; // You need to create this component
import { useNavigate } from 'react-router-dom';

const MODELE_COURRIEL_CREER_INCONNU = "Création d'un nouveau modèle de courriel";
const MODELE_COURRIEL_CREER_CONNU = "Création du modèle de courriel ";
const ALERT_MODELE_COURRIEL = "Modèle de courriel";
const ALERT_CREER_SUCESS = 'créé(e) avec succès!';

export default function CreerModeleCourriel(props: Partial<PropsDeCreationEntite<ModeleCourriel>>): ReactElement {
    const bsAlert = useAlertDialog();
    const navigate = useNavigate();

    const [valeursInitiales, setValeursInitiales] = useState<ModeleCourriel>(new ModeleCourriel());

    useEffect(() => {
        let title = "Nouveau modèle de courriel - Dashboard";
        if (valeursInitiales.name) {
            title = `${valeursInitiales.name} - Dashboard`;
        }
        document.title = title;
    }, [valeursInitiales.name]);

    function texteEntete(c: ModeleCourriel): JSX.Element {
        return (
            <>
                <small className="text-muted">
                    {c.name ? MODELE_COURRIEL_CREER_CONNU : MODELE_COURRIEL_CREER_INCONNU}
                </small>
                {c.name && c.name}
            </>
        );
    }

    function gererSucces(c: ModeleCourriel): void {
        if (valeursInitiales.id === undefined)
            bsAlert(`${ALERT_MODELE_COURRIEL} ${c.name} ${ALERT_CREER_SUCESS}`, 'success');
        setValeursInitiales(c);

        navigate('/dashboard/modeles-courriel/' + c.id, { replace: true });
    }

    return (
        <FormulaireCreationEntite
            texteEntete={texteEntete}
            entite={ModeleCourriel}
            succes={gererSucces}
            valeursInitiales={valeursInitiales}
            aussiEnvoyerCreated_at
            properties_to_reassign={{ id: 'id' }}
            {...props}
        >
            <ChampsModeleCourriel />
        </FormulaireCreationEntite>
    );
}
